import * as XLSX from 'xlsx';

export function normalizeDateToYyyyMmDd(value: unknown): string {
  if (value == null) return '';

  const pad = (n: number) => String(n).padStart(2, '0');

  if (value instanceof Date && !isNaN(value.getTime())) {
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
  }

  if (typeof value === 'string') {
    const s = value.trim();
    const parts = s
      .replace(/\./g, '/')
      .replace(/-/g, '/')
      .split('/')
      .filter(Boolean);
    if (parts.length === 3) {
      const [a, b, c] = parts;
      const numA = Number(a),
        numB = Number(b),
        numC = Number(c);
      if (!isNaN(numA) && !isNaN(numB) && !isNaN(numC)) {
        if (a.length === 4) return `${a}-${pad(numB)}-${pad(numC)}`;
        if (c.length === 4) return `${c}-${pad(numB)}-${pad(numA)}`;
      }
    }
    const d = new Date(s);
    if (!isNaN(d.getTime())) {
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    }
  }

  if (typeof value === 'number') {
    const parsed = XLSX.SSF.parse_date_code(value);
    if (parsed) {
      return `${parsed.y}-${pad(parsed.m)}-${pad(parsed.d)}`;
    }
  }

  return '';
}

export function sanitizeAmount(value: unknown): number {
  if (typeof value === 'number' && !Number.isNaN(value))
    return Math.round(value);
  if (!value && value !== 0) return 0;
  const s = String(value)
    .replace(/\./g, '')
    .replace(/,/g, '')
    .replace(/\s/g, '');
  const n = parseInt(s, 10);
  return Number.isNaN(n) ? 0 : n;
}
